import type { IOrgProjectLocationRepository } from '../repositories/IOrgProjectLocationRepository.js';

interface Deps { orgProjectLocationRepository: IOrgProjectLocationRepository; }

export function createUnsubscribeProjectLocationUseCase({ orgProjectLocationRepository }: Deps) {
  return async function unsubscribeProjectLocation(projectId: string, locationId: string): Promise<void> {
    return orgProjectLocationRepository.unsubscribeProject(projectId, locationId);
  };
}
